import React, { useEffect, useState } from 'react'
import { Link, useParams, useLocation } from 'react-router-dom'
import { Table } from 'react-bootstrap'
import {
  FeatherLoader,
  useErrorService,
  useUserService,
} from '@abroad/components'
import API from '../../utils/API'
import { formatDate } from '../../utils/date'

const GrowthPlanSOWTable = ({ growthPlanDetails, showAddSessionLink }) => {
  const [isLoading, setIsLoading] = useState(true)
  const [tableData, setTableData] = useState([])
  const { clientId } = useParams()
  const { user } = useUserService()
  const Error = useErrorService()
  const location = useLocation()
  const isUserComeFromMyClients = location?.pathname
    .split('/')
    .includes('coach')
  useEffect(() => {
    const getGrowthSOW = async () => {
      setIsLoading(true)
      try {
        const { data } = await API.AdminAPI.coachPlan.getGrowthSOW(clientId)
        if (data) {
          setTableData(data)
          setIsLoading(false)
        }
      } catch (e) {
        Error.showError(e)
        setIsLoading(false)
      }
    }
    getGrowthSOW()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [growthPlanDetails, clientId])

  return (
    <>
      <Table hover responsive className='custom-table mb-0'>
        <thead>
          <tr>
            <th width={user?.isAdmin ? '20%' : '25%'}>Coach</th>
            <th className='text-center' width='25%'>
              SOW Name
            </th>
            <th className='text-center' width={user?.isAdmin ? '15%' : '25%'}>
              Date
            </th>
            <th className='text-center' width={user?.isAdmin ? '20%' : '25%'}>
              Action
            </th>
          </tr>
        </thead>
        <tbody>
          {isLoading && (
            <tr>
              <td colSpan={4} className='text-center border-0'>
                <FeatherLoader />
              </td>
            </tr>
          )}
          {!isLoading && (
            <>
              {tableData.length === 0 ? (
                <tr>
                  <td colSpan={4} className='text-center border-0'>
                    Client has not taken any growth session yet.
                  </td>
                </tr>
              ) : (
                <>
                  {tableData.length > 0 &&
                    tableData.map((dataItem, index) => {
                      const isSessionDone = dataItem?.session?.date
                      const sowId = dataItem?.session?._id

                      return (
                        <tr key={index}>
                          <td width={user?.isAdmin ? '20%' : '25%'}>
                            {user?.isAdmin ? (
                              <Link
                                to={`/admin/coaches/${dataItem?.coachId?._id}`}
                                className='text-dark-900'>
                                {dataItem?.coachId?.fullName}
                              </Link>
                            ) : (
                              <>{dataItem?.coachId?.fullName}</>
                            )}
                          </td>
                          <td className='text-center' width='25%'>
                            {dataItem?.planName}
                          </td>
                          {!isSessionDone ? (
                            <td
                              className='text-center'
                              width={user?.isAdmin ? '25%' : '20%'}>
                              {' '}
                              -{' '}
                            </td>
                          ) : (
                            <td
                              className='text-center'
                              width={user?.isAdmin ? '25%' : '20%'}>
                              {formatDate(dataItem?.session?.date)}
                            </td>
                          )}

                          <td
                            className='text-center'
                            width={user?.isAdmin ? '30%' : '25%'}>
                            <Link
                              to={{
                                pathname: `${
                                  isUserComeFromMyClients
                                    ? '/coach/clients/'
                                    : '/admin/users/'
                                }${clientId}/growth-plan/${
                                  dataItem?._id
                                }/${sowId}/view`,
                                state: {
                                  isEditable:
                                    dataItem?.coachId?._id === user?._id,
                                },
                              }}>
                              View Session
                            </Link>
                            {/* )} */}
                          </td>
                        </tr>
                      )
                    })}
                </>
              )}
            </>
          )}
        </tbody>
      </Table>
    </>
  )
}

export default GrowthPlanSOWTable
